module.exports = __webpack_public_path__ + "media/10wormwood.8eee2d1a.mp3";